// ADDED
import axios from "../../api/apiClient";
import { domain, token } from "../../components/Security";

export const timeEntriesService = {
  getPayrollPeriodById: async (id) => {
    const response = await axios.get(`${domain}/api/PayrollPeriod/${id}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  },

  getEmployees: async () => {
    const response = await axios.get(`${domain}/api/Employee/masterlist`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  }
};